  const sliderThumbs = new Swiper(".top_toggled_tabs", {
  slidesPerView: 4.1,
  spaceBetween: 10,
  freeMode: true,
   slideToClickedSlide: true,
  breakpoints: {
    750: {
       slidesPerView: 6,
      spaceBetween: 10,
    }
  },
});
const sliderImages = new Swiper(".about-tabs_inner_content_outer", {
loop: false,
spaceBetween: 10,
slidesPerView: 1,
    thumbs: {
    swiper: sliderThumbs
  },
});
const aboutswiper = new Swiper('.about_slider_here.swiper.mySwiper', {
loop: true,
spaceBetween: 10,
slidesPerView: 1,
autoplay: {
delay: 2000,
disableOnInteraction: false,
},
breakpoints: {
750: {
slidesPerView: 3,
spaceBetween: 28
}
}
});
var mySwiper = new Swiper('.inside_reequil_slider.swiper.mySwiper', {
spaceBetween: 0,
centeredSlides: true,
speed: 6000,
autoplay: {
delay: 1,
},
loop: true,
slidesPerView:'auto',
allowTouchMove: false,
disableOnInteraction: true
});